const pagesCockpitEn = {
  approvalTasks: {
    empty: 'No pending approval tasks',
    error: 'Failed to fetch approval tasks',
    loading: 'Loading approval tasks...',
    tableHeaders: {
      applicant: 'Applicant',
      approvalFlow: 'Approval Flow',
      dueDate: 'Due Date',
      taskName: 'Approval Task'
    },
    trayTitle: 'Approval Tray'
  },
  detail: {
    actions: {
      approve: 'Approve (Mock)',
      reject: 'Return (Mock)'
    },
    error: 'Failed to fetch approval task',
    loading: 'Loading task details...'
  },
  header: {
    action1: 'Action 1',
    action2: 'Action 2',
    chatPlaceholder: 'Get your business operation done',
    recent: 'Recent',
    startOperationPackage: 'Start operation package'
  },
  operationTasks: {
    empty: {
      noTasks: 'No tasks are due.'
    },
    error: 'Failed to fetch tasks',
    loading: 'Loading tasks...',
    tableHeaders: {
      dueDate: 'Due Date',
      operation: 'Operation',
      progress: 'Progress',
      taskName: 'Task Name'
    },
    tabs: {
      hr: 'HR Department',
      month: 'Due This Month',
      today: 'Due Today',
      week: 'Due This Week'
    },
    title: 'Ongoing Tasks',
    viewToggle: {
      grid: 'Grid view',
      table: 'Table view'
    }
  },
  title: 'Cockpit'
};
export default pagesCockpitEn;